<template>
  <div class="item-manage">
    <el-card class="page-card">
      <el-form :inline="true" :model="filterForm" class="demo-form-inline">
        <el-form-item label="关键字">
          <el-input v-model="filterForm.keyword" placeholder="名称或备注" clearable></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="filterForm.typeId" placeholder="全部分类" clearable style="min-width:200px">
            <el-option v-for="type in types" :key="type.id" :label="type.name" :value="type.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadItems">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
          <el-button type="success" @click="openCreate">新增</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="items" v-loading="isLoading" style="width: 100%">
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="category" label="分类" width="140"></el-table-column>
        <el-table-column prop="location" label="存放位置" width="220"></el-table-column>
        <el-table-column prop="count" label="数量" width="80"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="viewItem(scope.row)">查看</el-button>
            <el-button size="mini" type="primary" @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </el-card>

    <el-dialog title="物品详情" :visible.sync="showDialog" width="40%">
      <div v-if="currentItem">
        <el-descriptions column="1" border>
          <el-descriptions-item label="名称">{{ currentItem.name }}</el-descriptions-item>
          <el-descriptions-item label="分类">{{ currentItem.category }}</el-descriptions-item>
          <el-descriptions-item label="存放位置">{{ currentItem.location }}</el-descriptions-item>
          <el-descriptions-item label="数量">{{ currentItem.count }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ currentItem.remark }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 新增/修改弹窗 -->
    <el-dialog :title="dialogMode === 'create' ? '新增物品' : '修改物品'" :visible.sync="showEditDialog" width="40%">
      <el-form :model="editForm" ref="itemFormRef" label-width="100px">
        <el-form-item label="名称" prop="name" :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>

        <el-form-item label="分类" prop="typeId">
          <el-select v-model="editForm.typeId" placeholder="请选择分类" @change="onTypeChange">
            <el-option v-for="t in types" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="存放位置">
          <el-input v-model="editForm.location"></el-input>
        </el-form-item>

        <el-form-item label="数量">
          <el-input-number v-model="editForm.count" :min="0"></el-input-number>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.remark" :autosize="{ minRows: 3 }"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取消</el-button>
        <el-button type="success" :loading="isSaving" @click="submitItem">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getItemList, addItem, updateItem, deleteItem } from '@/api/item'
import { getItemTypeList } from '@/api/itemType'

export default {
  name: 'ItemManage',
  data() {
    return {
      filterForm: {
        keyword: '',
        typeId: ''
      },
      items: [],
      types: [],
      isLoading: false,
      currentPage: 1,
      pageSize: 5,
      pageSizes: [5, 10, 20, 50, 100],
      total: 0,
      showDialog: false,
      currentItem: null,
      // 编辑/新增
      showEditDialog: false,
      dialogMode: 'create', // 'create' | 'edit'
      isSaving: false,
      editForm: {
        id: null,
        name: '',
        category: '',
        typeId: null,
        location: '',
        count: 0,
        remark: ''
      }
    }
  },
  created() {
    this.loadTypes()
    this.loadItems()
  },
  methods: {
    async loadTypes() {
      try {
        const res = await getItemTypeList()
        if (res && res.data && res.data.code === 200) {
          this.types = res.data.data || []
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取分类失败')
        }
      } catch (error) {
        // 检查是否是因为认证失败导致的错误（401/403）
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          // 认证相关的错误已经在 axios 拦截器中处理并跳转到登录页，无需额外提示
          console.log('Authentication failed, redirecting to login page')
          this.$message.error('长时间未操作，请重新登录')
        } else {
          this.$message.error('获取分类异常')
        }
      }
    },

    async loadItems() {
      this.isLoading = true
      try {
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          keyword: this.filterForm.keyword || undefined,
          typeId: this.filterForm.typeId || undefined
        }
        const res = await getItemList(params)
        if (res && res.data && res.data.code === 200) {
          const data = res.data.data || {}
          this.items = data.records || []
          this.total = data.total || 0
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取物品列表失败')
        }
      } catch (error) {
        // 检查是否是因为认证失败导致的错误（401/403）
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          // 认证相关的错误已经在 axios 拦截器中处理并跳转到登录页，无需额外提示
          console.log('Authentication failed, redirecting to login page')
          this.$message.error('长时间未操作，请重新登录')
        } else {
          this.$message.error('获取物品列表异常')
        }
      } finally {
        this.isLoading = false
      }
    },

    onTypeChange(typeId) {
      const t = this.types.find(x => x.id === typeId)
      if (t) {
        this.editForm.category = t.name
      } else {
        this.editForm.category = ''
      }
    },

    openCreate() {
      this.resetEditForm()
      this.dialogMode = 'create'
      this.showEditDialog = true
    },

    openEdit(row) {
      if (!row || !row.id) return
      this.dialogMode = 'edit'
      this.populateEditForm(row)
      this.showEditDialog = true
    },

    populateEditForm(item = {}) {
      this.editForm = {
        id: item.id || null,
        name: item.name || '',
        category: item.category || '',
        typeId: item.typeId || null,
        location: item.location || '',
        count: item.count || 0,
        remark: item.remark || ''
      }
      // 如果选择了typeId自动同步category
      if (this.editForm.typeId) {
        const t = this.types.find(x => x.id === this.editForm.typeId)
        if (t) this.editForm.category = t.name
      }
      if (this.$refs.itemFormRef && this.$refs.itemFormRef.clearValidate) {
        this.$refs.itemFormRef.clearValidate()
      }
    },

    resetEditForm() {
      this.editForm = { id: null, name: '', category: '', typeId: null, location: '', count: 0, remark: '' }
      if (this.$refs.itemFormRef && this.$refs.itemFormRef.resetFields) {
        this.$refs.itemFormRef.resetFields()
      }
    },

    async submitItem() {
      if (!this.editForm.name || !this.editForm.name.trim()) {
        this.$message.warning('请输入名称')
        return
      }
      const payload = {
        id: this.editForm.id,
        name: this.editForm.name.trim(),
        category: this.editForm.category || '',
        typeId: this.editForm.typeId,
        location: this.editForm.location || '',
        count: this.editForm.count || 0,
        remark: this.editForm.remark || ''
      }

      try {
        this.isSaving = true
        let res
        if (this.dialogMode === 'create') {
          res = await addItem(payload)
        } else {
          res = await updateItem(payload)
        }
        if (res && res.data && res.data.code === 200) {
          this.$message.success(this.dialogMode === 'create' ? '新增成功' : '修改成功')
          this.showEditDialog = false
          this.loadItems()
        } else {
          this.$message.error((res && res.data && res.data.msg) || '保存失败')
        }
      } catch (e) {
        const msg = e?.response?.data?.msg || e?.message || '保存异常'
        this.$message.error(msg)
      } finally {
        this.isSaving = false
      }
    },

    async handleDelete(row) {
      if (!row || !row.id) {
        this.$message.warning('无法删除，缺少记录ID')
        return
      }
      try {
        await this.$confirm(`确定要删除物品 "${row.name || '未命名'}" 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          modal: false
        })
        const res = await deleteItem(row.id)
        if (res && res.data && res.data.code === 200) {
          this.$message.success('删除成功')
          // 关闭详情对话框如果查看的是该项
          if (this.currentItem && this.currentItem.id === row.id) this.showDialog = false
          this.loadItems()
        } else {
          this.$message.error((res && res.data && res.data.msg) || '删除失败')
        }
      } catch (e) {
        if (e === 'cancel') return
        const msg = e?.response?.data?.msg || e?.message || '删除失败'
        this.$message.error(msg)
      }
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.loadItems()
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadItems()
    },

    resetFilters() {
      this.filterForm = { keyword: '', typeId: '' }
      this.currentPage = 1
      this.loadItems()
    },

    viewItem(row) {
      this.currentItem = row
      this.showDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.item-manage {
  .el-card { 
    margin-bottom: 12px;
    
    &.page-card {
      margin-top: -10px;
    }
  }
  // .pagination { margin-top: 12px; display: flex; justify-content: flex-end }
  .el-form-item {
    margin-bottom: 12px;
  }
}

/* 表格表头样式 */
:deep(.el-table__header-wrapper th),
:deep(.el-table__fixed-header-wrapper th) {
  background-color: #f5f7fa !important;
}
</style>
